import styled from "@emotion/styled";
import {Shell} from "@alifd/next";

export const NoHeaderShell = styled(Shell)`
    height: 100%;
    width: 100vw;
    .next-shell-header {
        display: none;
    }
`